<template>
  <div style="padding-top: 3px; padding-left: 0px;">
    <div id="shiftstatus">
      <h1 style="color: #000">Shift Close</h1><hr>
      <table align="center" style="width: 80%; text-align: left;">
        <tr><td>B1000 : </td><td>{{B1000}}</td></tr>
        <tr><td>B500 : </td><td>{{B1000}}</td></tr>
        <tr><td>B100 : </td><td>{{B100}}</td></tr>
        <tr><td>B50 : </td><td>{{B50}}</td></tr>
        <tr><td>B20 : </td><td>{{B20}}</td></tr>
        <tr><td>C10 : </td><td>{{C10}}</td></tr>
        <tr><td>C5 : </td><td>{{C5}}</td></tr>
        <tr><td>C2 : </td><td>{{C2}}</td></tr>
        <tr><td>C1 : </td><td>{{C1}}</td></tr>
        <tr><td>C050 : </td><td>{{C050}}</td></tr>
        <tr><td>C025 : </td><td>{{C025}}</td></tr>
        <tr><td>Shift_Amount : </td><td>{{shift_amount}}</td></tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import $ from "jquery";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Swal from "sweetalert2";
import api from "../../service/services";
export default {
  props: {
    shift_amount: '',
    B1000: '',
    B500: '',
    B100: '',
    B50: '',
    B20: '',
    C10: '',
    C5: '',
    C2: '',
    C1: '',
    C050: '',
    C025: '',
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState([
      "lang",
      "UUID",
      "accessToken",
      "Mode",
      "Type",
      "AuthenType",
    ]),
    ...mapMutations(["onMessageWs"])
  },
  methods: {
  },
  mounted() {
  }
};
</script>

<style>
  tr, td {
  border-bottom: 1px solid #ddd;
  font-size: 23px
}
</style>>



// WEBPACK FOOTER //
// src/components/modal/showcloseshift.vue